export default __webpack_public_path__ + "static/media/underrated_group_small.a923af67.svg";